<template>
    <div v-if="typeof previous_sub.sub_code != 'undefined' && previous_sub.sub_code">
        <div class="position-absolute pt-3 pr-4 f-95 fw-600 gray-500" style="right: 0; top: 0;">
            {{ $i18n.locale == 'ko' ? previous_campaign_name : previous_campaign_name_e }}
        </div>
        <sub-component :item="previous_sub"
            :sub_type="previous_sub.sub_type"
            :previous="true"
            :disabled="true"
            :is_disabled_by_parent="true"
            >
        </sub-component>
    </div>  
</template>

<script>
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';

export default {
    name: "DFPreviosSub",
    props: {
        company_id: {
            type: Number,
            reuqired: true 
        },
        company_name: {
            type: String,
            reuqired: true 
        },
        campaign_id: {
            type: Number,
            reuqired: true 
        },
        sub_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_init_id: {
            type: [Object, Number],
            required: false,
            default: null
        },
        sub_code: {
            type: String,
            required: true,
            default: 'ghg_policy'
        },
    },
    data () {
        return {
            previous_campaign_name: '',
            previous_sub: {}
        }
    },
    computed:{
        view_mode(){
            return this.$store.state.view_mode
        }
    },
    async created () {
        await this.getPreviousSub()
    },
    methods: {
        async getPreviousSub () {
            try {
                const _res_prev_subs = await this.$axios.get(`/subs/${this.sub_code}/prev`, {
                    params : {
                        sub_code : this.sub_code,
                        campaign_id: this.campaign_id,
                        company_id: this.company_id,
                        company_name: this.company_name
                    }
                })

                const data = _res_prev_subs.data
                // 빈 응답(null / [] / sub_code 없는 객체)이면 버튼 노출 막음 — custom e2bc236(2026-04-30) 동등 이식.
                // (테넌트 게이트로 숨기던 #334 는 오판이었음: custom 도 이 기능을 배포 중, 빈 응답 가드만 달랐다)
                if (data && !Array.isArray(data) && data.sub_code) {
                    this.previous_campaign_name = data.campaign_name
                    this.previous_campaign_name_e = data.campaign_name_e
                    this.previous_sub = generateSubcomponentDataBy(data)
                    this.$emit("previous-sub-loaded", true)
                }
            } catch (error) {
                console.log(` ~ error => `, error);
                if (error.response) {
                    console.log(` ~ error.response => `, error.response);
                }
            }
        }
    }
}
</script>